/**
 * @generated SignedSource<<866dc102e183b81e455633e98b448937>>
 * @relayHash c6cf9ac584fd64aa5d844966682fd423
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cf7fffeece47720251193fedf84eaf651e60962e8058f57b9b428bc916676a2c

import type { ConcreteRequest } from 'relay-runtime';
export type preloadContentSmartLinksViewPageExtensionsAndRendererAssetsQuery$variables = {
  contentId: string;
  smartLinksFromDraft?: boolean | null;
};
export type preloadContentSmartLinksViewPageExtensionsAndRendererAssetsQuery$data = {
  readonly confluence_contentSmartLinksForDraft?: {
    readonly nodes: ReadonlyArray<{
      readonly __typename: string;
      readonly canView: boolean;
      readonly emojiTitle: string | null;
      readonly iconUrl: string | null;
      readonly product: string | null;
      readonly resolved: boolean;
      readonly resourceType: string | null;
      readonly subType: string | null;
      readonly title: string | null;
      readonly url: string;
    } | null> | null;
  } | null;
  readonly contentSmartLinks?: {
    readonly nodes: ReadonlyArray<{
      readonly __typename: string;
      readonly canView: boolean;
      readonly emojiTitle: string | null;
      readonly iconUrl: string | null;
      readonly product: string | null;
      readonly resolved: boolean;
      readonly resourceType: string | null;
      readonly subType: string | null;
      readonly title: string | null;
      readonly url: string;
    } | null> | null;
  } | null;
};
export type preloadContentSmartLinksViewPageExtensionsAndRendererAssetsQuery = {
  response: preloadContentSmartLinksViewPageExtensionsAndRendererAssetsQuery$data;
  variables: preloadContentSmartLinksViewPageExtensionsAndRendererAssetsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "smartLinksFromDraft"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v2 = [
  {
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      {
        "kind": "ScalarField",
        "name": "url"
      },
      {
        "kind": "ScalarField",
        "name": "title"
      },
      {
        "kind": "ScalarField",
        "name": "emojiTitle"
      },
      {
        "kind": "ScalarField",
        "name": "canView"
      },
      {
        "kind": "ScalarField",
        "name": "product"
      },
      {
        "kind": "ScalarField",
        "name": "resourceType"
      },
      {
        "kind": "ScalarField",
        "name": "subType"
      },
      {
        "kind": "ScalarField",
        "name": "iconUrl"
      },
      {
        "kind": "ScalarField",
        "name": "resolved"
      }
    ]
  }
],
v3 = [
  {
    "condition": "smartLinksFromDraft",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedSmartLinkList",
        "kind": "LinkedField",
        "name": "contentSmartLinks",
        "plural": false,
        "selections": (v2/*: any*/)
      }
    ]
  },
  {
    "condition": "smartLinksFromDraft",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedSmartLinkList",
        "kind": "LinkedField",
        "name": "confluence_contentSmartLinksForDraft",
        "plural": false,
        "selections": (v2/*: any*/)
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "preloadContentSmartLinksViewPageExtensionsAndRendererAssetsQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "preloadContentSmartLinksViewPageExtensionsAndRendererAssetsQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "c6cf9ac584fd64aa5d844966682fd423",
    "id": "cf7fffeece47720251193fedf84eaf651e60962e8058f57b9b428bc916676a2c",
    "metadata": {},
    "name": "preloadContentSmartLinksViewPageExtensionsAndRendererAssetsQuery",
    "operationKind": "query",
    "text": "query preloadContentSmartLinksViewPageExtensionsAndRendererAssetsQuery($contentId:ID!,$smartLinksFromDraft:Boolean=false){contentSmartLinks(id:$contentId)@skip(if:$smartLinksFromDraft){nodes{__typename,url,title,emojiTitle,canView,product,resourceType,subType,iconUrl,resolved}},confluence_contentSmartLinksForDraft(id:$contentId)@include(if:$smartLinksFromDraft){nodes{__typename,url,title,emojiTitle,canView,product,resourceType,subType,iconUrl,resolved}}}"
  }
};
})();

(node as any).hash = "a7b959d9a7e601a6bc9a5abbe599241a";

export default node;
